import React, {useContext, useState, useRef} from 'react';
import VariousCompanyCards from './VariousCompanyCards';
import {SearchContext} from '../context/SearchContext';

const ShowMoreLawFirms = ({onShowPopup, onShowMore}) => {
    const {lawFirmResults, lawFirmPage, lawFirmTotalResults, loadingMore} = useContext(SearchContext);
    const [isLoading, setIsLoading] = useState(false);
    const scrollPositionRef = useRef(0);

    // Сохранение позиции скролла перед загрузкой новых данных
    const saveScrollPosition = () => {
        scrollPositionRef.current = window.scrollY || document.documentElement.scrollTop;
    };

    // Восстановление позиции скролла после загрузки новых данных
    const restoreScrollPosition = () => {
        window.scrollTo(0, scrollPositionRef.current);
    };

    const loadMoreCompanies = async () => {
        if (isLoading || loadingMore) return;
        saveScrollPosition();
        setIsLoading(true);
        await onShowMore(lawFirmPage + 1);
        setIsLoading(false);
        restoreScrollPosition();

    };

    const remainingLawFirms = Math.max((lawFirmTotalResults || 0) - lawFirmResults.length, 0);

    return (
        <div className="accordeon__el">
            <div className="accordeon__content">
                <VariousCompanyCards lawCompanies={lawFirmResults} onShowPopup={onShowPopup}/>
                {lawFirmResults.length < lawFirmTotalResults && (
                    <li className="show-all">
                        <div className="container">
                            <button onClick={loadMoreCompanies} disabled={isLoading || loadingMore}>
                                {loadingMore ? 'Loading...' : `Show More Law Firms${remainingLawFirms ? ` • ${remainingLawFirms}` : ''}`}
                            </button>
                        </div>
                    </li>
                )}
            </div>
        </div>
    );
};

export default ShowMoreLawFirms;
